import '@adornis/chemistry/elements/components/x-toggle-content.js';
import { logout } from '@adornis/users/client/loginFunctions.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { BHRegistrationFlowSubPage } from './bh-page-registration-sub-page.js';

@customElement('bh-page-registration-ldap-block')
export class BHPageRegistrationLdapBlock extends BHRegistrationFlowSubPage {
  override styles() {
    return [...super.styles(), { ':host': { flex: '1' } }];
  }

  override nextButtonDisabled = true;
  override backAction = () => this._registrationController.previous();
  override nextAction = () => {
    throw new Error('should not be called');
  };

  override content() {
    return html`
      <x-h3> ${this._translation.translate('REGISTRATION', 'ldap_required')} </x-h3>
      <x-button @click=${() => this.switchAccounts()}>
        ${this._translation.translate('REGISTRATION', 'switch_account')}
      </x-button>
    `;
  }

  private async switchAccounts() {
    await logout();
    this._registrationController.next(); // go to login step
  }
}
